// src/pages/DynamicSectionPage.js
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase';
import StaffSectionForm from '../components/StaffSectionForm';

export default function DynamicSectionPage() {
  const { sectionName } = useParams();              // e.g. "Cashup" or "Cash%20Up"
  const decoded = decodeURIComponent(sectionName);  // "Cashup" or "Cash Up"
  const normParam = decoded.replace(/\s+/g, '').toLowerCase();

  const [section, setSection] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      const snap = await getDocs(collection(db, 'dashContent'));
      const secs = snap.docs.map(d => ({ id: d.id, ...d.data() }));

      // find a section whose name, lower-stripped, matches
      const found = secs.find(s =>
        s.name.replace(/\s+/g, '').toLowerCase() === normParam
      );

      if (found) {
        setSection(found);
      } else {
        setSection(undefined);  // mark “not found”
      }
    })();
  }, [normParam]);

  if (section === null) {
    return <p>Loading {decoded}…</p>;
  }
  if (section === undefined) {
    return (
      <p style={{ color: 'red' }}>
        No section called “{decoded}” found.
      </p>
    );
  }

  // If they somehow ended up at /section/Cash-Up but you want to
  // redirect them to the clean URL without spaces:
  // un-comment this if desired:
  //
  // if (decoded.replace(/\s+/g, '') !== decoded) {
  //   return <Navigate to={`/section/${section.name}`} replace />;
  // }

  return <StaffSectionForm section={section} />;
}
